import React from 'react';
import defaultUserImage from "assets/img/no_profile.png";
import cellfind from "assets/img/cellfind.png";
import panacea from "assets/img/panacea.jpg";
import simigenix from "assets/img/simigenix.png";
import { Avatar } from '@material-ui/core';

export default (props) => {
    const { accountSize, image, company, companySize } = props;
    return (
        <div style={{ position: "relative", width: accountSize ? accountSize : 36, height: accountSize ? accountSize : 36 }}>
            <Avatar
                style={{ position: "relative", width: accountSize ? accountSize : 36, height: accountSize ? accountSize : 36 }}
                src={image ? ("/api/image/get?id=" + image) : defaultUserImage}
            />
            <Avatar
                src={(company === "Cellfind" ? cellfind : (company === "Panacea" ? panacea : simigenix))}
                style={{ position: 'absolute', bottom: 0, right: 0, height: companySize ? companySize : 18, width: companySize ? companySize : 18 }}
            />
        </div>
    );
}
